
export const transformOptions = (options) => options ? options.map(option => ({
    value: option.id,
    label: option.name
})) : []
